export default "__VITE_ASSET__Nug8FaV7__"